import FormInputNumber from "../../shared/FormInputNumber";
import { fetchCoverageTierSetHistoryFact, fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from "../../../utils/apiUtils";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import FormSelect from "../../shared/FormSelect";
import { SLOT_NAMES } from "../../../utils/constants";
import FormCheckbox from "../../shared/FormCheckbox";
import FormDate from "../../shared/FormDate";
import FormInputText from "../../shared/FormInputText";

const step = 2
const today = new Date();
const formattedToday = new Intl.DateTimeFormat("en-US").format(today);

const StepTwo = ({ activeStep, control, errors, register, setValue, getValues }) => {
    if (activeStep !== step) return

    const template = getValues("template")
    const shouldOverridePlanYearDate = getValues("shouldOverridePlanYearDate")
    const planYearStartDateOverride = getValues("planYearStartDateOverride")

    const { data: depedentAgeOutOptions } = useQuery({
        queryKey: ['depedentAgeOutOptions'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.INVALID_MEMBER,
        //     //    bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),
        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.INVALID_MEMBER,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),


        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    const { data: coverageTierFromTempalate } = useQuery({
        queryKey: ['coverageTierFromTempalte'],
        queryFn: async () => await fetchCoverageTierSetHistoryFact({
            coverageTierSetKey: template?.additional?.coverageTierSetKey,
        }),
        select: (data) => data.rows[0],
        enabled: !!template?.additional?.bnftPlanTemplateHstFctKey,
    })

    const { data: coverageTierSetRiderOptions } = useQuery({
        queryKey: ['coverageTierSetRiderOptions'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     //category: 'Coordination of Benefits Rules',
        //     searchText: 'Coverage Tier Set Rider',
        //     // bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        // }),
        // select: (data) => data.hits.hits
        //     .map(hit => hit._source.metadata)
        //     .filter((metadata) => !!metadata.benefitPlanRiderHccId)
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanRiderHccId,
        //         label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata,
        //     })),
        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            benefitPlanRiderTypeName: 'Coverage Tier Set',
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),
        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    return (
        <>
            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>Coverage Tier</p>
            {/* <FormInputText
                label={'Coverage Tier from template'}
                register={register}
                name={'defaultCoverageTier'}
                errors={errors}
                placeholder="CoveragetTier" /> */}
            <div className="form-input">
                <label htmlFor={'coverageTierSet'}>Coverage Tier Set (from template)</label>
                <input
                    style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                    type="text"
                    id={"coverageTierSet"}
                    placeholder="search..."
                    disabled={true}
                    // list="items"
                    autoComplete="off"
                    // onFocus={() => setCurrentPage(0)}
                    // onChange={(e) => {
                    //     setSearchValue(e.target.value);
                    //     debouncedChangeHandler(e);
                    // }}
                    value={coverageTierFromTempalate?.coverageTierSetName}
                />
            </div>

            <FormSelect
                label={"Overwrite Coverage Tier Set"}
                name={'coverageTierSetRider'}
                control={control}
                options={coverageTierSetRiderOptions}
                errors={errors}
                placeholder="Select a coverage tier set"
            />

            {/* <div style={{ display: "flex", gap: "1rem", padding: "1rem 0rem 1rem 0rem" }}>
                <FormInputAsycnPaginate
                    label={"Overwrite Coverage Tier Set "}
                    name={"coverageTier"}
                    control={control}
                    loadOptions={loadCoverageTier}
                    errors={errors} />
            </div> */}

            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>Dependent Age Out Policy (default is EOM)</p>
            <div style={{ display: 'flex', gap: '1rem' }}>
                <FormInputText
                    name={"dependentAgeOutPolicy"}
                    label={`Default`}
                    errors={errors}
                    register={register}
                    disabled={true}
                    style={{ width: '85px' }}
                />
                <FormSelect
                    label={'Overwrite Dependent age out'}
                    name={'dependentAgeOutPolicyRider'}
                    control={control}
                    options={depedentAgeOutOptions}
                    errors={errors}
                    placeholder="Select..."
                    disabled={false}
                />
            </div>
            <p style={{ fontWeight: 600, fontSize: '1.2rem', }}>Dates</p>
            <div style={{ display: "flex", gap: "1rem", padding: "1rem 0rem 3rem 0rem" }}>
                <div className="form-input" style={{ position: "relative", border: "none", padding: ".2rem 0rem" }}>
                    <label style={{}}>Effective start date</label>
                    <input
                        {...register("effectiveStartDate")}
                        name="effectiveStartDate"
                        style={{ padding: ".8rem" }}
                        type={"date"}
                        placeholder="Effective Start Date"
                        autoComplete="off"
                        // value={checkInDateValue}
                        min={formattedToday}
                    // onChange={(e) => {
                    //     setCheckInDateValue(e.target.value)
                    // }}
                    />
                    {errors.effectiveStartDate && (
                        <p className="danger" style={{ color: "var(--red)", paddingTop: ".4rem" }}>
                            {errors.effectiveStartDate?.message}
                        </p>
                    )}
                </div>

                {/* <div className="form-input" style={{ position: "relative", border: "none", padding: ".2rem 0rem" }}>
                    <label style={{}}>Effective end date</label>
                    <input
                        style={{ padding: ".8rem" }}
                        {...register("effectiveEndDate")}
                        type="date"
                        placeholder="Effective End Date"
                        autoComplete="off"
                        // value={checkOutDateValue}
                        min={formattedMinCheckOut}
                    // onChange={(e) => {
                    //     // setCheckOutDateValue(e.target.value)
                    //     if (isValid) {
                    //         if (isValid) {
                    //             submitForm(getValues())
                    //         }
                    //     }
                    // }}
                    />
                    {errors.effectiveEndDate && (
                        <p className="danger" style={{ color: "var(--red)", paddingTop: ".4rem" }}>
                            {errors.effectiveEndDate?.message}
                        </p>
                    )}
                </div> */}
            </div>

            <div style={{ display: "flex", gap: "1rem", padding: "1rem 0rem 1rem 0rem" }}>
                {/* <div className="form-input">
                    <label>Plan Start Month</label>
                    <input {...register("planStartMonthday.planStartMonth")} style={{ height: "48px" }} type="month" />
                    {errors["planStartMonthday.planStartMonth"] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors["planStartMonthday.planStartMonth"]?.message}</p>}
                </div> */}
                {/* <FormInputNumber name={"planStartMonthday.planStartDay"} label={`Plan Start Day`} errors={errors} register={register} /> */}
            </div>

            <div style={{ display: "flex", gap: "1rem", padding: "0rem 0rem 1rem 0rem" }}>
                <FormInputNumber name={"planRenewalInteraval"} label={`Plan Renewal Interval (In months)`} errors={errors} register={register} />

                {/* <div className="form-input">
                    <label>Accumulator Reset Date</label>
                    <input {...register("accumulatorResetDate")} style={{ height: "48px" }} type="date" />
                    {errors["accumulatorResetDate"] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors["accumulatorResetDate"]?.message}</p>}
                </div> */}

                <div >
                    {/* Plan start Month Day |  */}
                    <label style={{}}>Accum Reset date</label>

                    <Controller
                        name="planStartMonthday" // Name of the field in your form data
                        control={control} // The control object from useForm
                        render={({ field }) => (
                            <div style={{ paddingTop: '.6rem' }}>
                                <DatePicker
                                    className="date-picker"
                                    selected={field.value} // Value from react-hook-form's state
                                    onChange={(date) => field.onChange(date)} // Update react-hook-form's state on change
                                    dateFormat="MMMM dd" // Optional: specify date format
                                />
                            </div>
                        )}
                    />
                    {errors.planStartMonthday && (
                        <p className="danger" style={{ color: "var(--red)", paddingTop: ".4rem" }}>
                            {errors.planStartMonthday?.message}
                        </p>
                    )}
                </div>
            </div>

            <FormCheckbox
                label={`Override Plan Year Date`}
                name={`shouldOverridePlanYearDate`}
                register={register}
                control={control}
                style={{ paddingBottom: '2rem' }}
                onSelectedHandler={(checked) => {
                    if (!checked) {
                        setValue('planYearDateOverride', null);
                    }
                }}
            />

            {shouldOverridePlanYearDate && <div style={{ display: 'flex', gap: '1rem', justifyContent: 'space-between', width: '100%' }}>
                <FormDate label={'Plan Year Start Date'}
                    name={'planYearDateOverride.planYearStartDateOverride'}
                    control={control}
                    errors={errors}
                    onChangeHandler={() => setValue('planYearDateOverride.planYearEndDateOverride', null)}
                />
                <FormDate label={'Plan Year End Date'}
                    name={'planYearDateOverride.planYearEndDateOverride'}
                    control={control}
                    errors={errors}
                    min={planYearStartDateOverride}
                />
            </div>}
            {errors['planYearDateOverride'] &&
                <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{'Invalid Plan year'}</p>}
        </>
    )
}

export default StepTwo
